<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <!-- Avatar Col -->
      <div class="vx-col">
        <div class="img-container mb-4">
          <vs-avatar size="200px" :src="data.photo" :text="data.userName" />
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ data.corporateName }}</h2>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          label="Nome"
          v-model="data.userName"
          name="name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          label="Email"
          v-model="data.email"
          type="email"
          name="email"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>
      </div>
    </div>
    <br />
    <br>
    <div class="vx-row">
       <div class="vx-col md:w-full mt-5">
        <vs-button
          color="danger"
          type="filled"
          icon-pack="feather"
          icon="icon-trash-2"
          class="float-left"
          @click="deleteUser(data.idUserCustomer)"
          >Apagar</vs-button
        >
        <vs-button
          class="float-right"
          type="filled"
          @click="updateUser"
          :disabled="!isFormValid"
          icon-pack="feather"
          icon="icon-save"
          >Salvar</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { baseApiUrl } from "@/global";
import { Validator } from "vee-validate";
import axios from "axios";
const dict = {
  custom: {
    name: {
      required: "Por favor insira nome",
      alpha: "Your first name may only contain alphabetic characters",
    },
    email: {
      required: "Por favor insira a senha",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
export default {
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: {},
    };
  },
  computed: {
    isFormValid() {
      return !this.errors.any() && this.data.userName && this.data.email;
    },
  },
  methods: {
    async deleteUser(idUserCustomer){
      try {
        this.$vs.loading();
        await axios.post(
          `${baseApiUrl}/userCustomers/deleteUser`,
         {idUserCustomer}
        );
        this.$vs.loading.close();
        this.$router.push(`/usuarios`);
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async updateUser() {
      let result = this.$validator.validateAll();
      if (result) {
        try {
          this.user = {
            idUserCustomer: this.data.idUserCustomer,
            userName: this.data.userName,
            email: this.data.email,
          };

          this.$vs.loading();
          await axios.post(`${baseApiUrl}/userCustomers/updateUser`, this.user);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Salvo",
            text: "com Sucesso",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          this.$router.push(`/usuarios`);
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Não foi possivel salvar " + error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      } else {
        return;
      }
    },
  },
  async created() {},
};
</script>
